/*
 * @Descripttion: 发票录入页
 * @Author: cb4786
 * @Date: 2023-08-10 16:57:56
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-28 14:45:02
 */

import { ReactNode } from 'react'
import { OrderType } from '../../tools/public'
import styles from './styles.module.scss'
import useHook from './hooks'
import SupplierInvoiceEntry from './SupplierInvoice'
import LanderInvoiceEntry from './LanderInvoice'
import { Tabs } from 'antd'

const InvoiceEntry = () => {
  const { changeOrder, checkedOrderKey, orderCount, permissionList } = useHook()
  const menuList: {
    key: OrderType
    component: ReactNode
    title: string
  }[] = []

  if (permissionList.length === 1 && permissionList.includes('电商供应商')) {
    menuList.push({
      key: 'CUSTOMER',
      component: <LanderInvoiceEntry />,
      title: '电商供应商订单',
    })
  }

  if (permissionList.length === 1 && permissionList.includes('自营供应商')) {
    menuList.push({
      key: 'SUPPLIER',
      component: <SupplierInvoiceEntry />,
      title: '供应商订单',
    })
  }

  if (permissionList.length === 0 || permissionList.length === 2) {
    menuList.push(
      {
        key: 'CUSTOMER',
        component: <LanderInvoiceEntry />,
        title: '电商供应商订单',
      },
      {
        key: 'SUPPLIER',
        component: <SupplierInvoiceEntry />,
        title: '供应商订单',
      },
    )
  }

  const getMainContent = (key: string) => {
    return menuList.find((item) => item.key === key)?.component
  }

  return (
    <div className={styles.main}>
      <Tabs
        type="card"
        activeKey={checkedOrderKey}
        onTabClick={(keyname) => {
          changeOrder(keyname)
        }}
      >
        {menuList.map((item) => {
          return (
            <Tabs.TabPane
              tab={`${item.title}（${orderCount[item.key]}）`}
              key={item.key}
            >
              {getMainContent(item.key)}
            </Tabs.TabPane>
          )
        })}
      </Tabs>
    </div>
  )
}

export default InvoiceEntry
/*
 * @Descripttion: 发票录入页
 * @Author: cb4786
 * @Date: 2023-08-10 16:57:56
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-28 14:45:02
 */

import { ReactNode } from 'react'
import { OrderType } from '../../tools/public'
import styles from './styles.module.scss'
import useHook from './hooks'
import SupplierInvoiceEntry from './SupplierInvoice'
import LanderInvoiceEntry from './LanderInvoice'
import { Tabs } from 'antd'

const InvoiceEntry = () => {
  const { changeOrder, checkedOrderKey, orderCount, permissionList } = useHook()
  const menuList: {
    key: OrderType
    component: ReactNode
    title: string
  }[] = []

  if (permissionList.length === 1 && permissionList.includes('电商供应商')) {
    menuList.push({
      key: 'CUSTOMER',
      component: <LanderInvoiceEntry />,
      title: '电商供应商订单',
    })
  }

  if (permissionList.length === 1 && permissionList.includes('自营供应商')) {
    menuList.push({
      key: 'SUPPLIER',
      component: <SupplierInvoiceEntry />,
      title: '供应商订单',
    })
  }

  if (permissionList.length === 0 || permissionList.length === 2) {
    menuList.push(
      {
        key: 'CUSTOMER',
        component: <LanderInvoiceEntry />,
        title: '电商供应商订单',
      },
      {
        key: 'SUPPLIER',
        component: <SupplierInvoiceEntry />,
        title: '供应商订单',
      },
    )
  }

  const getMainContent = (key: string) => {
    return menuList.find((item) => item.key === key)?.component
  }

  return (
    <div className={styles.main}>
      <Tabs
        type="card"
        activeKey={checkedOrderKey}
        onTabClick={(keyname) => {
          changeOrder(keyname)
        }}
      >
        {menuList.map((item) => {
          return (
            <Tabs.TabPane
              tab={`${item.title}（${orderCount[item.key]}）`}
              key={item.key}
            >
              {getMainContent(item.key)}
            </Tabs.TabPane>
          )
        })}
      </Tabs>
    </div>
  )
}

export default InvoiceEntry
